module.exports = __webpack_public_path__ + "assets/img/home-2025-logo-banner.86e9b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-2025-logo-banner.png
// module id = 582
// module chunks = 1